// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip-link {\n  text-decoration: underline;\n}\n.invoice-info__line .rest-description {\n  word-break: break-word;\n}\n", ""]);
// Exports
module.exports = exports;
